import { useSelector } from "react-redux";
import type {
    AssignToOtherUsersButtonProps,
} from "../../components/AssignToOtherUsersButton/AssignToOtherUsersButton";
import AssignToOtherUsersButton from "../../components/AssignToOtherUsersButton/AssignToOtherUsersButton";
import { selectAssignIsInProgress } from "../../store/selectors";

export type AssignToOtherUsersButtonBaseContainerProps = Omit<AssignToOtherUsersButtonProps, "isLoading">;

const AssignToOtherUsersButtonBaseContainer = (props: AssignToOtherUsersButtonBaseContainerProps) => {
    const isAssignInProgress = useSelector(selectAssignIsInProgress);

    return (
        <AssignToOtherUsersButton
            {...props}
            isLoading={isAssignInProgress}
        />
    );
}

export default AssignToOtherUsersButtonBaseContainer;
